const MS_PER_DAY = 24 * 60 * 60 * 1000
const MIN_GAP_PARTS = 10
const LABEL_MARGIN = 4
const LEVEL_MARGIN = 6

const dayNumber = (day) => {
  const [year, month, date] = String(day).split('-').map(Number)
  return Date.UTC(year, month - 1, date) / MS_PER_DAY
}

export const axisPositions = (days) => {
  const numbers = days.map(dayNumber)
  const minGap = (numbers[numbers.length - 1] - numbers[0]) / MIN_GAP_PARTS
  return numbers.reduce((positions, number, index) => (
    index === 0
      ? [0]
      : [...positions, positions[index - 1] + Math.max(number - numbers[index - 1], minGap)]
  ), [])
}

export const labelRotation = (gap, labelWidth, labelHeight) => {
  if (!(gap > 0) || gap >= labelWidth + LEVEL_MARGIN) return 0
  const needed = (labelHeight + LABEL_MARGIN) / gap
  return needed >= 1 ? 90 : (Math.asin(needed) * 180) / Math.PI
}
